import React, { useState } from "react";
import { FormBox } from "./FormBox";
import { TableBox } from "./TableBox";
import { FixedBottom } from "./FixedBottom";
import { AddAssetsDrawer } from "./AddAssetsDrawer";
import useNavModel, { RouterParamType } from "@/model/navModel";


export const ManageAssetsEntryDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);

    return (
        <>
            {detailsInfo && <>
                <FormBox {...detailsInfo} />
                <TableBox {...detailsInfo} />
                <FixedBottom {...detailsInfo} />
                <AddAssetsDrawer {...detailsInfo} />
            </>
            }
        </>
    )
}